import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {AchievementDialog} from "../dialog/AchievementDialogComponent";

export class AchievementDialogService {

    public static readonly id = "achievementDialogService";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService) {

    }

    public async open(): Promise<void> {
        const options: IModalSettings = {
            component: AchievementDialog,
            backdrop: "static",
            size: "fs",
            controllerAs: "ctrl"
        };
        const instance = this.$uibModal.open(options);
        return instance.result;
    }
}